export default __webpack_public_path__ + "static/media/banner.6554f91f.jpg";